import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCampaignLayerContent } from '../../../../../../queries';
import DragDrop from '../../../../../SharedComponents/DragDrop/DragDrop';
import { ProgressSpinner } from 'primereact/progressspinner';

const AreaContentPreview = ({ areaId, onAddContent, isDarkMode = false, isAreaMuted = false, onPublish, isCompact = false, showDuration = false }) => {
    const { t } = useTranslation();
    const { data, isLoading } = useGetCampaignLayerContent(areaId, "MAIN");
    const [isOpen, setIsOpen] = React.useState(false);

    if (isLoading) return <div className="flex justify-center p-2"><ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="4" /></div>;

    return (
        <div className={`mt-3 pt-2 border-t transition-colors ${isDarkMode ? 'border-slate-700' : 'border-gray-200'}`}>
            <div className="flex justify-between items-center ">
                <div
                    className={`flex items-center gap-2 cursor-pointer p-1 rounded flex-grow transition-colors ${
                        isDarkMode ? 'hover:bg-slate-700' : 'hover:bg-gray-100'
                    }`}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <i className={`bx bx-chevron-${isOpen ? 'up' : 'down'} ${isDarkMode ? 'text-slate-400' : 'text-gray-500'}`}></i>
                    <span className={`text-xs font-bold select-none ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                        {t('layouts.designer_linked_content', { count: data?.length || 0 })}
                    </span>
                </div>
                
                 <button
                    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold transition-all duration-200 border shadow-sm ${
                        isDarkMode 
                        ? 'text-indigo-400 bg-indigo-900/30 border-indigo-500/30 hover:bg-indigo-900/50 hover:text-indigo-300' 
                        : 'text-indigo-600 bg-indigo-50 hover:bg-indigo-100 hover:text-indigo-700 border-indigo-100'
                    }`}
                    onClick={onAddContent}
                    title={t('layouts.designer_add_content')}
                >
                    <i className="bx bx-plus text-sm"></i>
                    <span>{t('layouts.designer_add_media')}</span>
                </button>
            </div>

            {isOpen && (
                <div className="mt-2 scale-90 origin-top-left w-[110%] max-h-[300px] overflow-y-auto pr-2 custom-scrollbar">
                    {(!data || data.length === 0) ? (
                        <div className={`text-xs text-center py-2 italic ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>{t('layouts.designer_no_content_assigned')}</div>
                    ) : (
                        <DragDrop data={data} areaId={areaId} isDarkMode={isDarkMode} isAreaMuted={isAreaMuted} onPublish={onPublish} isCompact={isCompact} showDuration={showDuration} />
                    )}
                </div>
            )}
        </div>
    );
};

export default AreaContentPreview;
